export default __webpack_public_path__ + "static/media/kangpagoda.318b1fcc.jpg";